import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-6.641 3.359a.75.75 0 0 1-1.06 0L12 13.06l-2.298 2.298a.75.75 0 1 1-1.06-1.061L10.938 12 8.641 9.702a.75.75 0 0 1 1.06-1.06L12 10.938l2.298-2.298a.75.75 0 0 1 1.06 1.06L13.062 12l2.298 2.298a.75.75 0 0 1 0 1.06"
      clipRule="evenodd"
    />
  </svg>
);
export const IconRemoveCircleSolid = withDynamicStroke(Icon);
